export const defaultMaxHeight = 686

export const internalExplorerUrl = 'https://scan.li.fi'
